export default __webpack_public_path__ + "static/media/task_payment_reminder_icon.f16d8da8.svg";